import React, {Component} from "react";
import Glob from "../../libs/Glob.mjs";
import "../SubNavBar.css";
import appLib from "../../libs/appLib.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import UserIcon from "../../media/assets/UserIcon.mjs";
import LockIcon from "../../media/assets/LockIcon.mjs";
import AppOffroIcon from "../../media/assets/AppOffroIcon.mjs";
import AppAbutIcon from "../../media/assets/AppAboutIcon.mjs";
import AppCercoIcon from "../../media/assets/AppCercoIcon.mjs";
import AboutBacheca from "./AboutBacheca.mjs";
import UserIndex from "./Login/UserIndex.mjs";
import Messaggi from "./Messaggi/Messaggi.mjs";
import BachecaAdmin from "./Admin/BachecaAdmin.mjs";
import "./Bacheca.css";
import AppModIcon from "../../media/assets/AppModIcon.mjs";

const prefix = 'Bacheca';

const Bacheca = class extends Component {
	constructor(props) {
		super(props);
		const u = appLib.currentUser();
		this.state = {
			user: u,
			canAdmin: (u?.admin||u?.moderator),
			accepted: Glob.getStatus('bacheca_accepted'),
		};
		this.pane = this.pane.bind(this);
		this.selectPane = this.selectPane.bind(this);
		this.uid = Glob.generateUid(prefix);
	}
	componentDidMount() {
		Glob.register( 'currentPage', mo => {
			const p = mo?.params?.pane;
			if ( p && p !== this.state.pane ) this.setState({ pane: this.state.accepted ? p : 'about' });
		}, this.uid);
		Glob.register( 'bacheca_accepted', x => {
			this.setState({ accepted: x });
		}, this.uid);
		Glob.register('currentUser', ui => {
			this.setState({user: ui, canAdmin: (ui?.admin||ui?.moderator)});
		}, this.uid);
		const p = (this.state.accepted && Glob.getPageParam('pane')) || (this.state.accepted ? 'offro' : 'about');
		if ( p !== Glob.getPageParam('pane') ) {
			Glob.setCurrentPageParam('pane', p);
		} else if ( p !== this.state.pane ) {
			this.setState({ pane: p });
		}
	}
	componentWillUnmount() {
		Glob.deregister( this.uid );
	}
	selectPane(x) {
		Glob.setCurrentPageParam('pane', x);
	}
	pane(x) {
		const accepted = !! this.state.accepted;
		if ( typeof x === 'undefined' ) {
			x = Glob.getPageParam("pane") || (accepted ? 'offro' : 'about');
		} else if ( ! accepted ) {
			x = 'about';
		}
		switch ( x ) {
			case 'offro': return <Messaggi axle={"offro"} />;
			case 'cerco': return <Messaggi axle={"cerco"} />;
			case 'user': return <UserIndex />;
			case 'admin': return <BachecaAdmin />;
			default: return <AboutBacheca />;
		}
	}
	render() {
		return (
			<div className={prefix} id={this.uid}>
				<div
					className={prefix+"SubNavBar SubNavBar "+(this.state.accepted ? 'enabled' : 'disabled')}>
					<div
						onClick={ ()=>{ this.selectPane('about'); } }
						className={ 'minor '+(this.state.pane === 'about' ? 'active' : 'inactive') }
					>
						<AppAbutIcon />
						<span>
							<TextLabel value={"About"} />
						</span>
					</div>
					<div
						onClick={ ()=>{
							if (this.state.pane === 'user') {
								Glob.trigger('my_user_messages', false);
							} else {
								this.selectPane('user');
							}
						}}
						className={ 'minor '+(this.state.pane === 'user' ? 'active plus' : 'inactive') }
					>
						{ this.state.user ? <LockIcon /> : <UserIcon /> }
						<span>
							<TextLabel value={this.state.user ? "User" : "Login"} />
						</span>
					</div>
					<div
						onClick={ ()=>{ this.selectPane('offro'); } }
						className={ this.state.pane === 'offro' ? 'active' : 'inactive' }
					>
						<AppOffroIcon />
						<span>
							<TextLabel value={"Offering"} />
						</span>
					</div>
					<div
						onClick={ ()=>{ this.selectPane('cerco'); } }
						className={ this.state.pane === 'cerco' ? 'active' : 'inactive' }
					>
						<AppCercoIcon />
						<span>
							<TextLabel value={"Wanted"} />
						</span>
					</div>
					{ !! this.state.canAdmin && (
						<div
							onClick={ ()=>{ this.selectPane('admin'); } }
							className={ 'minor '+(this.state.pane === 'admin' ? 'active' : 'inactive') }
						>
							<AppModIcon />
							<span>
								<TextLabel value={"Moderation"} />
							</span>
						</div>
					)}
				</div>
				<div
					className={"SubNavContent"}
					key={ this.state.pane }
				>
					{ this.pane(this.state.pane) }
				</div>
			</div>
		)
	}
}

export default Bacheca;
